<template>
  <div>
     <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3"></TitleCard>
     <a-card class="all-card-style " >
   <!--      搜索模块-->
      <div class="search-box">
        <a-form layout="inline">

          <a-form-item
            label="名称"  class="ant-form-item2"
          >
            <a-input
              placeholder="请输入名称"  v-model="paramas.keyword"
            >
              <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" html-type="submit" @click="handlePageList"  >
              查询
            </a-button>
          </a-form-item>
           <a-form-item>
            <a-button type="primary"  @click="export2Excel"  html-type="submit" >
              导出
            </a-button>
          </a-form-item>
           <a-form-item>
            <a-button type="primary" v-print="'#printTest'"   html-type="submit" >
              打印
            </a-button>
          </a-form-item>
        </a-form>
      </div>
      <!-- 搜索 -->

       <!--      列表表格-->
            <div style="margin-top:20px;">
               <a-button type="primary" html-type="button" @click="toAddPage">
         +新 建
        </a-button>

              <a-table   id="printTest" @change="handleTableChange" :pagination="pagination" :columns="columns"
                          :data-source="data" :row-selection="rowSelection"  style="margin-top:20px;">
          <span slot="action" slot-scope="text, record">
           <div>
                  <a @click="showDeleteModal(record)">删除</a>
    <a-divider type="vertical"/>
               <a @click="toEditPage(record)">修改</a>
             <a-divider type="vertical"/>
             <a   @click="toDistPage(record)"   >派发</a></div>
          </span>

              </a-table>

            </div>
      <!-- 列表 -->
     </a-card>

    <!--              弹出框-->
    <a-modal v-model="deleteModalVisible" title="删除" @ok="handleDelete" ok-text="确认" cancel-text="取消">
      <p>是否删除</p>
    </a-modal>

  </div>
</template>
<script>
import TitleCard from '@/components/TitleCard.vue'

const columns = [

  {
    title: '称号',
    dataIndex: 'cTaskName',
    key: 'cTaskName',
    className: 'column-money'
  },
  {
    title: '地块名称',
    dataIndex: 'cSceneName',
    key: 'cSceneName',
    className: 'column-money'
  },
  {
    title: '工作内容',
    dataIndex: 'cTaskContent',
    key: 'cTaskContent',
    className: 'column-money'
  },
  {
    title: '工作状态',
    dataIndex: 'StatusName',
    key: 'StatusName',
    className: 'column-money'
  },
  {
    title: '开始时间',
    dataIndex: 'dStartDate',
    key: 'dStartDate',
    className: 'column-money'
  },
  {
    title: '结束时间',
    dataIndex: 'dEndDate',
    key: 'dEndDate',
    className: 'column-money'

  },
  {
    title: '派发时间',
    dataIndex: 'dDistDate',
    key: 'dDistDate',
    className: 'column-money'
  },
  {
    title: '完成时间',
    dataIndex: 'dFinishDate',
    key: 'dFinishDate',
    className: 'column-money'
  },
  {
    title: '操作',
    dataIndex: 'num',
    key: 'num',
    className: 'column-money',
    scopedSlots: { customRender: 'action' }
  }
]

// 表格前选择
const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
  },
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows)
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    console.log(selected, selectedRows, changeRows)
  }
}

export default {
  name: 'logList',
  components: {
    TitleCard
  },
  data () {
    return {
      titleMsg1: '生产管理',
      titleMsg2: '工单管理',
      titleMsg3: '工单管理',
      titleMsg4: '工单派发',
      data: [

      ],
      columns,
      paramas: {
        keyword: '',
        sceneId: '',
        cEntID: '',
        page: 1,
        limit: 10,
        userID: ''
      },
      rowSelection,
      deleteModalVisible: false,
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共有 ${total} 条数据` // 分页中显示总的数据
      },

      record: {}
    }
  },
  mounted () {
    const that = this
    that.paramas.sceneId = that.$store.getters.SCene.ID
    that.paramas.cEntID = that.$store.getters.User.enterprise.ID

    that.$bus.$on('scenechange', (target) => {
      that.paramas.sceneId = target.id
      that.handlePageList()
    })
    that.handlePageList()
  },
  methods: {
    print () {
      this.$print(this.$refs.prints)
    },
    export2Excel () {
      const that = this

      require.ensure([], () => {
        const { export_json_to_excel } = require('vendor/Export2Excel')
        // 头
        const tHeader = ['称号', '地块名称', '工作内容', '工作状态']
        // 对应的标签
        const filterVal = ['cTaskName', 'cSceneName', 'cTaskContent', 'StatusName']
        // 标签对应的内容  是一个数组结构
        const list = that.data
        // 一个方法 我也不知道干嘛的
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, '投喂excel')
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    handleTableChange (pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.paramas.page = pagination.current
      this.paramas.limit = pagination.pageSize
      this.handlePageList()
    },
    async handlePageList () {
      const that = this
      that.paramas.userID = that.$store.getters.User.ID
      that.paramas.cSystemCode = '设施园艺'
      const res = await that.$http.post('EntWorkOrderTask/PageList', that.paramas)

      if (res.data.code == '200') {
        that.data = res.data.obj.list
      } else {
        that.$message.error(res.message)
      }
    },
    // 删除
    async handleDelete () {
      const that = this
      const param = { ids: that.record.ID }
      const res = await that.$http.post('EntWorkOrderTask/sDel?ids=' + that.record.ID, param)

      if (res.data.code == '200') {
        this.deleteModalVisible = false
        that.$message.success(res.data.message)
        that.handlePageList()
      } else {
        that.$message.error(res.message)
      }
    },
    showDeleteModal: function (obj) {
      this.record = obj
      this.deleteModalVisible = true
    },
    toEditPage (obj) {
      const that = this
      this.$router.push({ name: 'WorkOrderManagementNewAdd', params: { ID: obj.ID, sceneId: that.paramas.sceneId } })
    },
    toDistPage (obj) {
      const that = this
      this.$router.push({ name: 'WorkOrderManagementDist', params: { ID: obj.ID, sceneId: that.paramas.sceneId } })
    },
    toAddPage () {
      this.$router.push({ path: '/productionManagement/workordermanagement/WorkOrderManagementNewAdd' })
    }

  }
}

</script>
